import styled from 'styled-components';
import PropTypes from 'prop-types';
import theme from '../../../theme';

const ProgressBar = styled.div`
  background: ${(props) => props.background};
  height: 10px;
  position: relative;
  
  &::after {
    content: "";
    position: absolute;
    top:0;
    left:0;
    height: 100%;
    width: ${(props) => props.percentage}%;
    background: ${(props) => props.color};
  }
`;

ProgressBar.propTypes = {
  color: PropTypes.string,
  background: PropTypes.string,
  percentage: PropTypes.number,
};
ProgressBar.defaultProps = {
  color: theme.colors.primary,
  background: theme.colors.darker,
};

export default ProgressBar;
